/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppAccountRouteImport } from './routes/_app/account'
import { Route as AppBrandKitRouteImport } from './routes/_app/brand-kit'
import { Route as AppCalendarRouteImport } from './routes/_app/calendar'
import { Route as AppHelpRouteImport } from './routes/_app/help'
import { Route as AppInsightsRouteImport } from './routes/_app/insights'
import { Route as AppNotificationsRouteImport } from './routes/_app/notifications'
import { Route as AppVoiceRouteImport } from './routes/_app/voice'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as AuthEmailChangeRouteImport } from './routes/auth/email-change'
import { Route as AuthResetPasswordRouteImport } from './routes/auth/reset-password'
import { Route as DataDeletionCodeRouteImport } from './routes/data-deletion/$code'
import { Route as EmailsTokenRouteImport } from './routes/emails/$token'
import { Route as LegalDocumentRouteImport } from './routes/legal/$document'
import { Route as AppCyclesCycleIdRouteImport } from './routes/_app/cycles/$cycleId'
import { Route as AppOnboardingIndexRouteImport } from './routes/_app/onboarding/index'
import { Route as AppOnboardingBrandRouteImport } from './routes/_app/onboarding/brand'
import { Route as AppOnboardingCycleRouteImport } from './routes/_app/onboarding/cycle'
import { Route as AppOnboardingInstagramRouteImport } from './routes/_app/onboarding/instagram'
import { Route as AppOnboardingProfileRouteImport } from './routes/_app/onboarding/profile'
import { Route as AppOnboardingProjectRouteImport } from './routes/_app/onboarding/project'
import { Route as AppOnboardingVoiceRouteImport } from './routes/_app/onboarding/voice'
import { Route as AppProjectsIndexRouteImport } from './routes/_app/projects/index'
import { Route as AppProjectsNewRouteImport } from './routes/_app/projects/new'
import { Route as PublicSignInIndexRouteImport } from './routes/_public/sign-in/index'
import { Route as PublicSignInEmailRouteImport } from './routes/_public/sign-in/email'
import { Route as PublicSignUpIndexRouteImport } from './routes/_public/sign-up/index'
import { Route as PublicSignUpEmailRouteImport } from './routes/_public/sign-up/email'
import { Route as AppHelpGuidesTradeRouteImport } from './routes/_app/help_.guides.$trade'
import { Route as AppProjectsProjectIdIndexRouteImport } from './routes/_app/projects/$projectId/index'
import { Route as AppProjectsProjectIdCycleRouteImport } from './routes/_app/projects/$projectId/cycle'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountRoute = AppAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AppRoute,
} as any)
const AppBrandKitRoute = AppBrandKitRouteImport.update({
  id: '/brand-kit',
  path: '/brand-kit',
  getParentRoute: () => AppRoute,
} as any)
const AppCalendarRoute = AppCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => AppRoute,
} as any)
const AppHelpRoute = AppHelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => AppRoute,
} as any)
const AppInsightsRoute = AppInsightsRouteImport.update({
  id: '/insights',
  path: '/insights',
  getParentRoute: () => AppRoute,
} as any)
const AppNotificationsRoute = AppNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AppRoute,
} as any)
const AppVoiceRoute = AppVoiceRouteImport.update({
  id: '/voice',
  path: '/voice',
  getParentRoute: () => AppRoute,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthEmailChangeRoute = AuthEmailChangeRouteImport.update({
  id: '/auth/email-change',
  path: '/auth/email-change',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/auth/reset-password',
  path: '/auth/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const DataDeletionCodeRoute = DataDeletionCodeRouteImport.update({
  id: '/data-deletion/$code',
  path: '/data-deletion/$code',
  getParentRoute: () => rootRouteImport,
} as any)
const EmailsTokenRoute = EmailsTokenRouteImport.update({
  id: '/emails/$token',
  path: '/emails/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalDocumentRoute = LegalDocumentRouteImport.update({
  id: '/legal/$document',
  path: '/legal/$document',
  getParentRoute: () => rootRouteImport,
} as any)
const AppCyclesCycleIdRoute = AppCyclesCycleIdRouteImport.update({
  id: '/cycles/$cycleId',
  path: '/cycles/$cycleId',
  getParentRoute: () => AppRoute,
} as any)
const AppOnboardingIndexRoute = AppOnboardingIndexRouteImport.update({
  id: '/onboarding/',
  path: '/onboarding/',
  getParentRoute: () => AppRoute,
} as any)
const AppOnboardingBrandRoute = AppOnboardingBrandRouteImport.update({
  id: '/onboarding/brand',
  path: '/onboarding/brand',
  getParentRoute: () => AppRoute,
} as any)
const AppOnboardingCycleRoute = AppOnboardingCycleRouteImport.update({
  id: '/onboarding/cycle',
  path: '/onboarding/cycle',
  getParentRoute: () => AppRoute,
} as any)
const AppOnboardingInstagramRoute = AppOnboardingInstagramRouteImport.update({
  id: '/onboarding/instagram',
  path: '/onboarding/instagram',
  getParentRoute: () => AppRoute,
} as any)
const AppOnboardingProfileRoute = AppOnboardingProfileRouteImport.update({
  id: '/onboarding/profile',
  path: '/onboarding/profile',
  getParentRoute: () => AppRoute,
} as any)
const AppOnboardingProjectRoute = AppOnboardingProjectRouteImport.update({
  id: '/onboarding/project',
  path: '/onboarding/project',
  getParentRoute: () => AppRoute,
} as any)
const AppOnboardingVoiceRoute = AppOnboardingVoiceRouteImport.update({
  id: '/onboarding/voice',
  path: '/onboarding/voice',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsIndexRoute = AppProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsNewRoute = AppProjectsNewRouteImport.update({
  id: '/projects/new',
  path: '/projects/new',
  getParentRoute: () => AppRoute,
} as any)
const PublicSignInIndexRoute = PublicSignInIndexRouteImport.update({
  id: '/sign-in/',
  path: '/sign-in/',
  getParentRoute: () => PublicRoute,
} as any)
const PublicSignInEmailRoute = PublicSignInEmailRouteImport.update({
  id: '/sign-in/email',
  path: '/sign-in/email',
  getParentRoute: () => PublicRoute,
} as any)
const PublicSignUpIndexRoute = PublicSignUpIndexRouteImport.update({
  id: '/sign-up/',
  path: '/sign-up/',
  getParentRoute: () => PublicRoute,
} as any)
const PublicSignUpEmailRoute = PublicSignUpEmailRouteImport.update({
  id: '/sign-up/email',
  path: '/sign-up/email',
  getParentRoute: () => PublicRoute,
} as any)
const AppHelpGuidesTradeRoute = AppHelpGuidesTradeRouteImport.update({
  id: '/help_/guides/$trade',
  path: '/help/guides/$trade',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsProjectIdIndexRoute =
  AppProjectsProjectIdIndexRouteImport.update({
    id: '/projects/$projectId/',
    path: '/projects/$projectId/',
    getParentRoute: () => AppRoute,
  } as any)
const AppProjectsProjectIdCycleRoute =
  AppProjectsProjectIdCycleRouteImport.update({
    id: '/projects/$projectId/cycle',
    path: '/projects/$projectId/cycle',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/account': typeof AppAccountRoute
  '/brand-kit': typeof AppBrandKitRoute
  '/calendar': typeof AppCalendarRoute
  '/help': typeof AppHelpRoute
  '/insights': typeof AppInsightsRoute
  '/notifications': typeof AppNotificationsRoute
  '/voice': typeof AppVoiceRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/email-change': typeof AuthEmailChangeRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/data-deletion/$code': typeof DataDeletionCodeRoute
  '/emails/$token': typeof EmailsTokenRoute
  '/legal/$document': typeof LegalDocumentRoute
  '/cycles/$cycleId': typeof AppCyclesCycleIdRoute
  '/onboarding/brand': typeof AppOnboardingBrandRoute
  '/onboarding/cycle': typeof AppOnboardingCycleRoute
  '/onboarding/instagram': typeof AppOnboardingInstagramRoute
  '/onboarding/profile': typeof AppOnboardingProfileRoute
  '/onboarding/project': typeof AppOnboardingProjectRoute
  '/onboarding/voice': typeof AppOnboardingVoiceRoute
  '/projects/new': typeof AppProjectsNewRoute
  '/sign-in/email': typeof PublicSignInEmailRoute
  '/sign-up/email': typeof PublicSignUpEmailRoute
  '/onboarding/': typeof AppOnboardingIndexRoute
  '/projects/': typeof AppProjectsIndexRoute
  '/sign-in/': typeof PublicSignInIndexRoute
  '/sign-up/': typeof PublicSignUpIndexRoute
  '/help/guides/$trade': typeof AppHelpGuidesTradeRoute
  '/projects/$projectId/cycle': typeof AppProjectsProjectIdCycleRoute
  '/projects/$projectId/': typeof AppProjectsProjectIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AppIndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/account': typeof AppAccountRoute
  '/brand-kit': typeof AppBrandKitRoute
  '/calendar': typeof AppCalendarRoute
  '/help': typeof AppHelpRoute
  '/insights': typeof AppInsightsRoute
  '/notifications': typeof AppNotificationsRoute
  '/voice': typeof AppVoiceRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/email-change': typeof AuthEmailChangeRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/data-deletion/$code': typeof DataDeletionCodeRoute
  '/emails/$token': typeof EmailsTokenRoute
  '/legal/$document': typeof LegalDocumentRoute
  '/cycles/$cycleId': typeof AppCyclesCycleIdRoute
  '/onboarding/brand': typeof AppOnboardingBrandRoute
  '/onboarding/cycle': typeof AppOnboardingCycleRoute
  '/onboarding/instagram': typeof AppOnboardingInstagramRoute
  '/onboarding/profile': typeof AppOnboardingProfileRoute
  '/onboarding/project': typeof AppOnboardingProjectRoute
  '/onboarding/voice': typeof AppOnboardingVoiceRoute
  '/projects/new': typeof AppProjectsNewRoute
  '/sign-in/email': typeof PublicSignInEmailRoute
  '/sign-up/email': typeof PublicSignUpEmailRoute
  '/onboarding': typeof AppOnboardingIndexRoute
  '/projects': typeof AppProjectsIndexRoute
  '/sign-in': typeof PublicSignInIndexRoute
  '/sign-up': typeof PublicSignUpIndexRoute
  '/help/guides/$trade': typeof AppHelpGuidesTradeRoute
  '/projects/$projectId/cycle': typeof AppProjectsProjectIdCycleRoute
  '/projects/$projectId': typeof AppProjectsProjectIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/_app/account': typeof AppAccountRoute
  '/_app/brand-kit': typeof AppBrandKitRoute
  '/_app/calendar': typeof AppCalendarRoute
  '/_app/help': typeof AppHelpRoute
  '/_app/insights': typeof AppInsightsRoute
  '/_app/notifications': typeof AppNotificationsRoute
  '/_app/voice': typeof AppVoiceRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/email-change': typeof AuthEmailChangeRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/data-deletion/$code': typeof DataDeletionCodeRoute
  '/emails/$token': typeof EmailsTokenRoute
  '/legal/$document': typeof LegalDocumentRoute
  '/_app/': typeof AppIndexRoute
  '/_app/cycles/$cycleId': typeof AppCyclesCycleIdRoute
  '/_app/onboarding/brand': typeof AppOnboardingBrandRoute
  '/_app/onboarding/cycle': typeof AppOnboardingCycleRoute
  '/_app/onboarding/instagram': typeof AppOnboardingInstagramRoute
  '/_app/onboarding/profile': typeof AppOnboardingProfileRoute
  '/_app/onboarding/project': typeof AppOnboardingProjectRoute
  '/_app/onboarding/voice': typeof AppOnboardingVoiceRoute
  '/_app/projects/new': typeof AppProjectsNewRoute
  '/_public/sign-in/email': typeof PublicSignInEmailRoute
  '/_public/sign-up/email': typeof PublicSignUpEmailRoute
  '/_app/onboarding/': typeof AppOnboardingIndexRoute
  '/_app/projects/': typeof AppProjectsIndexRoute
  '/_public/sign-in/': typeof PublicSignInIndexRoute
  '/_public/sign-up/': typeof PublicSignUpIndexRoute
  '/_app/help_/guides/$trade': typeof AppHelpGuidesTradeRoute
  '/_app/projects/$projectId/cycle': typeof AppProjectsProjectIdCycleRoute
  '/_app/projects/$projectId/': typeof AppProjectsProjectIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/account'
    | '/brand-kit'
    | '/calendar'
    | '/help'
    | '/insights'
    | '/notifications'
    | '/voice'
    | '/auth/callback'
    | '/auth/email-change'
    | '/auth/reset-password'
    | '/data-deletion/$code'
    | '/emails/$token'
    | '/legal/$document'
    | '/cycles/$cycleId'
    | '/onboarding/brand'
    | '/onboarding/cycle'
    | '/onboarding/instagram'
    | '/onboarding/profile'
    | '/onboarding/project'
    | '/onboarding/voice'
    | '/projects/new'
    | '/sign-in/email'
    | '/sign-up/email'
    | '/onboarding/'
    | '/projects/'
    | '/sign-in/'
    | '/sign-up/'
    | '/help/guides/$trade'
    | '/projects/$projectId/cycle'
    | '/projects/$projectId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/account'
    | '/brand-kit'
    | '/calendar'
    | '/help'
    | '/insights'
    | '/notifications'
    | '/voice'
    | '/auth/callback'
    | '/auth/email-change'
    | '/auth/reset-password'
    | '/data-deletion/$code'
    | '/emails/$token'
    | '/legal/$document'
    | '/cycles/$cycleId'
    | '/onboarding/brand'
    | '/onboarding/cycle'
    | '/onboarding/instagram'
    | '/onboarding/profile'
    | '/onboarding/project'
    | '/onboarding/voice'
    | '/projects/new'
    | '/sign-in/email'
    | '/sign-up/email'
    | '/onboarding'
    | '/projects'
    | '/sign-in'
    | '/sign-up'
    | '/help/guides/$trade'
    | '/projects/$projectId/cycle'
    | '/projects/$projectId'
  id:
    | '__root__'
    | '/_app'
    | '/_public'
    | '/forgot-password'
    | '/_app/account'
    | '/_app/brand-kit'
    | '/_app/calendar'
    | '/_app/help'
    | '/_app/insights'
    | '/_app/notifications'
    | '/_app/voice'
    | '/auth/callback'
    | '/auth/email-change'
    | '/auth/reset-password'
    | '/data-deletion/$code'
    | '/emails/$token'
    | '/legal/$document'
    | '/_app/'
    | '/_app/cycles/$cycleId'
    | '/_app/onboarding/brand'
    | '/_app/onboarding/cycle'
    | '/_app/onboarding/instagram'
    | '/_app/onboarding/profile'
    | '/_app/onboarding/project'
    | '/_app/onboarding/voice'
    | '/_app/projects/new'
    | '/_public/sign-in/email'
    | '/_public/sign-up/email'
    | '/_app/onboarding/'
    | '/_app/projects/'
    | '/_public/sign-in/'
    | '/_public/sign-up/'
    | '/_app/help_/guides/$trade'
    | '/_app/projects/$projectId/cycle'
    | '/_app/projects/$projectId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  AuthEmailChangeRoute: typeof AuthEmailChangeRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  DataDeletionCodeRoute: typeof DataDeletionCodeRoute
  EmailsTokenRoute: typeof EmailsTokenRoute
  LegalDocumentRoute: typeof LegalDocumentRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/account': {
      id: '/_app/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AppAccountRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/brand-kit': {
      id: '/_app/brand-kit'
      path: '/brand-kit'
      fullPath: '/brand-kit'
      preLoaderRoute: typeof AppBrandKitRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/calendar': {
      id: '/_app/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof AppCalendarRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/help': {
      id: '/_app/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof AppHelpRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/insights': {
      id: '/_app/insights'
      path: '/insights'
      fullPath: '/insights'
      preLoaderRoute: typeof AppInsightsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/notifications': {
      id: '/_app/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AppNotificationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/voice': {
      id: '/_app/voice'
      path: '/voice'
      fullPath: '/voice'
      preLoaderRoute: typeof AppVoiceRouteImport
      parentRoute: typeof AppRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/email-change': {
      id: '/auth/email-change'
      path: '/auth/email-change'
      fullPath: '/auth/email-change'
      preLoaderRoute: typeof AuthEmailChangeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/reset-password': {
      id: '/auth/reset-password'
      path: '/auth/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/data-deletion/$code': {
      id: '/data-deletion/$code'
      path: '/data-deletion/$code'
      fullPath: '/data-deletion/$code'
      preLoaderRoute: typeof DataDeletionCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/emails/$token': {
      id: '/emails/$token'
      path: '/emails/$token'
      fullPath: '/emails/$token'
      preLoaderRoute: typeof EmailsTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal/$document': {
      id: '/legal/$document'
      path: '/legal/$document'
      fullPath: '/legal/$document'
      preLoaderRoute: typeof LegalDocumentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/cycles/$cycleId': {
      id: '/_app/cycles/$cycleId'
      path: '/cycles/$cycleId'
      fullPath: '/cycles/$cycleId'
      preLoaderRoute: typeof AppCyclesCycleIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/onboarding/': {
      id: '/_app/onboarding/'
      path: '/onboarding'
      fullPath: '/onboarding/'
      preLoaderRoute: typeof AppOnboardingIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/onboarding/brand': {
      id: '/_app/onboarding/brand'
      path: '/onboarding/brand'
      fullPath: '/onboarding/brand'
      preLoaderRoute: typeof AppOnboardingBrandRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/onboarding/cycle': {
      id: '/_app/onboarding/cycle'
      path: '/onboarding/cycle'
      fullPath: '/onboarding/cycle'
      preLoaderRoute: typeof AppOnboardingCycleRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/onboarding/instagram': {
      id: '/_app/onboarding/instagram'
      path: '/onboarding/instagram'
      fullPath: '/onboarding/instagram'
      preLoaderRoute: typeof AppOnboardingInstagramRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/onboarding/profile': {
      id: '/_app/onboarding/profile'
      path: '/onboarding/profile'
      fullPath: '/onboarding/profile'
      preLoaderRoute: typeof AppOnboardingProfileRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/onboarding/project': {
      id: '/_app/onboarding/project'
      path: '/onboarding/project'
      fullPath: '/onboarding/project'
      preLoaderRoute: typeof AppOnboardingProjectRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/onboarding/voice': {
      id: '/_app/onboarding/voice'
      path: '/onboarding/voice'
      fullPath: '/onboarding/voice'
      preLoaderRoute: typeof AppOnboardingVoiceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/': {
      id: '/_app/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof AppProjectsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/new': {
      id: '/_app/projects/new'
      path: '/projects/new'
      fullPath: '/projects/new'
      preLoaderRoute: typeof AppProjectsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_public/sign-in/': {
      id: '/_public/sign-in/'
      path: '/sign-in'
      fullPath: '/sign-in/'
      preLoaderRoute: typeof PublicSignInIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/sign-in/email': {
      id: '/_public/sign-in/email'
      path: '/sign-in/email'
      fullPath: '/sign-in/email'
      preLoaderRoute: typeof PublicSignInEmailRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/sign-up/': {
      id: '/_public/sign-up/'
      path: '/sign-up'
      fullPath: '/sign-up/'
      preLoaderRoute: typeof PublicSignUpIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/sign-up/email': {
      id: '/_public/sign-up/email'
      path: '/sign-up/email'
      fullPath: '/sign-up/email'
      preLoaderRoute: typeof PublicSignUpEmailRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_app/help_/guides/$trade': {
      id: '/_app/help_/guides/$trade'
      path: '/help/guides/$trade'
      fullPath: '/help/guides/$trade'
      preLoaderRoute: typeof AppHelpGuidesTradeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/$projectId/': {
      id: '/_app/projects/$projectId/'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId/'
      preLoaderRoute: typeof AppProjectsProjectIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/$projectId/cycle': {
      id: '/_app/projects/$projectId/cycle'
      path: '/projects/$projectId/cycle'
      fullPath: '/projects/$projectId/cycle'
      preLoaderRoute: typeof AppProjectsProjectIdCycleRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAccountRoute: typeof AppAccountRoute
  AppBrandKitRoute: typeof AppBrandKitRoute
  AppCalendarRoute: typeof AppCalendarRoute
  AppHelpRoute: typeof AppHelpRoute
  AppInsightsRoute: typeof AppInsightsRoute
  AppNotificationsRoute: typeof AppNotificationsRoute
  AppVoiceRoute: typeof AppVoiceRoute
  AppIndexRoute: typeof AppIndexRoute
  AppCyclesCycleIdRoute: typeof AppCyclesCycleIdRoute
  AppOnboardingBrandRoute: typeof AppOnboardingBrandRoute
  AppOnboardingCycleRoute: typeof AppOnboardingCycleRoute
  AppOnboardingInstagramRoute: typeof AppOnboardingInstagramRoute
  AppOnboardingProfileRoute: typeof AppOnboardingProfileRoute
  AppOnboardingProjectRoute: typeof AppOnboardingProjectRoute
  AppOnboardingVoiceRoute: typeof AppOnboardingVoiceRoute
  AppProjectsNewRoute: typeof AppProjectsNewRoute
  AppOnboardingIndexRoute: typeof AppOnboardingIndexRoute
  AppProjectsIndexRoute: typeof AppProjectsIndexRoute
  AppHelpGuidesTradeRoute: typeof AppHelpGuidesTradeRoute
  AppProjectsProjectIdCycleRoute: typeof AppProjectsProjectIdCycleRoute
  AppProjectsProjectIdIndexRoute: typeof AppProjectsProjectIdIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAccountRoute: AppAccountRoute,
  AppBrandKitRoute: AppBrandKitRoute,
  AppCalendarRoute: AppCalendarRoute,
  AppHelpRoute: AppHelpRoute,
  AppInsightsRoute: AppInsightsRoute,
  AppNotificationsRoute: AppNotificationsRoute,
  AppVoiceRoute: AppVoiceRoute,
  AppIndexRoute: AppIndexRoute,
  AppCyclesCycleIdRoute: AppCyclesCycleIdRoute,
  AppOnboardingBrandRoute: AppOnboardingBrandRoute,
  AppOnboardingCycleRoute: AppOnboardingCycleRoute,
  AppOnboardingInstagramRoute: AppOnboardingInstagramRoute,
  AppOnboardingProfileRoute: AppOnboardingProfileRoute,
  AppOnboardingProjectRoute: AppOnboardingProjectRoute,
  AppOnboardingVoiceRoute: AppOnboardingVoiceRoute,
  AppProjectsNewRoute: AppProjectsNewRoute,
  AppOnboardingIndexRoute: AppOnboardingIndexRoute,
  AppProjectsIndexRoute: AppProjectsIndexRoute,
  AppHelpGuidesTradeRoute: AppHelpGuidesTradeRoute,
  AppProjectsProjectIdCycleRoute: AppProjectsProjectIdCycleRoute,
  AppProjectsProjectIdIndexRoute: AppProjectsProjectIdIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface PublicRouteChildren {
  PublicSignInEmailRoute: typeof PublicSignInEmailRoute
  PublicSignUpEmailRoute: typeof PublicSignUpEmailRoute
  PublicSignInIndexRoute: typeof PublicSignInIndexRoute
  PublicSignUpIndexRoute: typeof PublicSignUpIndexRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicSignInEmailRoute: PublicSignInEmailRoute,
  PublicSignUpEmailRoute: PublicSignUpEmailRoute,
  PublicSignInIndexRoute: PublicSignInIndexRoute,
  PublicSignUpIndexRoute: PublicSignUpIndexRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  AuthEmailChangeRoute: AuthEmailChangeRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  DataDeletionCodeRoute: DataDeletionCodeRoute,
  EmailsTokenRoute: EmailsTokenRoute,
  LegalDocumentRoute: LegalDocumentRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
